import React, { useState, useEffect } from 'react'
import { ErrorMessage, FieldArray, Formik } from 'formik'
import { InputField } from '../../../../../components'
import Layout from '../../../../brands/components/Layout'
import { Button, Form, InputGroup } from 'react-bootstrap'
import { Icon } from '@iconify/react'
import './index.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { questionnaireSchema } from '../schema'
import { createQuestions, getQuestions } from '../../api'
import { transformPayload } from '../utils'
import { Questionnaire } from '../../type'
import { useAppDispatch } from '../../../../../redux/hook'
import {
    HIDE_LOADER,
    SHOW_LOADER,
} from '../../../../../redux/slices/LoaderSlice'
import { SHOW_NOTIFICATION } from '../../../../../redux/slices/showNotificationSlice'

const CreateQuestion: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const location = useLocation()
    const pathname = location.pathname
    const resourceId = pathname.substring(pathname.lastIndexOf('/') + 1)

    const [questionnaireData, setQuestionnaireData] = useState<Questionnaire>(
        {}
    )
    const [questionnaireId, setQuestionnaireId] = useState<string>('')

    useEffect(() => {
        const fetchData = async () => {
            dispatch(SHOW_LOADER())
            try {
                const response = await getQuestions(resourceId)
                if (response.data.resourceQuestionnaire !== null) {
                    setQuestionnaireData(response.data.resourceQuestionnaire)
                    setQuestionnaireId(
                        response.data.resourceQuestionnaire.questionnaireId
                    )
                } else {
                    setQuestionnaireData({})
                }
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        fetchData()
    }, [resourceId])

    return (
        <div>
            <Layout custom={true}>
                <div className="">
                    <div className="mb-3">
                        <h4>Create Questionnaire</h4>
                    </div>
                    <div className="questionnaire-form">
                        <Formik
                            enableReinitialize
                            initialValues={{
                                questionnaireTitle:
                                    questionnaireData?.questionnaireTitle
                                        ? questionnaireData?.questionnaireTitle
                                        : '',
                                passingScore: questionnaireData?.passingScore
                                    ? questionnaireData?.passingScore
                                    : '',
                                questions:
                                    questionnaireData?.questionnaireQuestions
                                        ? questionnaireData.questionnaireQuestions.map(
                                              (question: any) => ({
                                                  ...question,
                                                  questionOptions:
                                                      question.questionOptions.map(
                                                          (option: string) => ({
                                                              text: option,
                                                              correct:
                                                                  option ===
                                                                  question.correctAnswer,
                                                          })
                                                      ),
                                              })
                                          )
                                        : [
                                              {
                                                  questionTitle: '',
                                                  questionOptions: [
                                                      {
                                                          text: '',
                                                          correct: false,
                                                      },
                                                      {
                                                          text: '',
                                                          correct: false,
                                                      },
                                                      {
                                                          text: '',
                                                          correct: false,
                                                      },
                                                      {
                                                          text: '',
                                                          correct: false,
                                                      },
                                                  ],
                                                  correctAnswer: undefined,
                                              },
                                          ],
                            }}
                            validationSchema={questionnaireSchema}
                            onSubmit={async (values) => {
                                dispatch(SHOW_LOADER())
                                const transformedPayload: Questionnaire =
                                    transformPayload(
                                        values,
                                        resourceId,
                                        questionnaireId
                                    )

                                try {
                                    const response =
                                        await createQuestions(
                                            transformedPayload
                                        )
                                    if (response) {
                                        dispatch(HIDE_LOADER())
                                        dispatch(
                                            SHOW_NOTIFICATION({
                                                type: 'success',
                                                message:
                                                    'Questionnaire added successfully',
                                            })
                                        )
                                        navigate(-1)
                                    }
                                } catch (err) {
                                    console.error('Error')
                                    dispatch(HIDE_LOADER())
                                }
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6 col-md-8 bg-green-color">
                                            <InputField
                                                type="text"
                                                lable={'Title'}
                                                name="questionnaireTitle"
                                                value={
                                                    values.questionnaireTitle
                                                }
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={
                                                    typeof errors.questionnaireTitle ===
                                                    'string'
                                                        ? errors.questionnaireTitle
                                                        : undefined
                                                }
                                                touched={
                                                    typeof touched.questionnaireTitle ===
                                                    'boolean'
                                                        ? touched.questionnaireTitle
                                                        : undefined
                                                }
                                                placeholder="Questionnaire Title"
                                            />
                                        </div>

                                        <div className="col-sm-6 col-md-4 bg-green-color">
                                            <InputField
                                                type="number"
                                                lable={'Passing Score:'}
                                                name="passingScore"
                                                value={values.passingScore.toString()}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={
                                                    typeof errors.passingScore ===
                                                    'string'
                                                        ? errors.passingScore
                                                        : undefined
                                                }
                                                touched={
                                                    typeof touched.passingScore ===
                                                    'boolean'
                                                        ? touched.passingScore
                                                        : undefined
                                                }
                                            />
                                        </div>
                                    </div>
                                    <FieldArray name="questions">
                                        {({ push, remove: removeQuestion }) => (
                                            <div>
                                                {values.questions.map(
                                                    (
                                                        question: any,
                                                        questionIndex: number
                                                    ) => (
                                                        <div
                                                            key={questionIndex}
                                                        >
                                                            <div className="row mrg-top">
                                                                <div className="col-sm-6 col-md-12 bg-green-color">
                                                                    <div>
                                                                        <label>
                                                                            Question{' '}
                                                                            {questionIndex +
                                                                                1}
                                                                        </label>
                                                                        <Icon
                                                                            style={{
                                                                                float: 'right',
                                                                            }}
                                                                            cursor={
                                                                                'pointer'
                                                                            }
                                                                            icon="icon-park-outline:delete"
                                                                            className="icon-secondary"
                                                                            color="#DA0808"
                                                                            onClick={() =>
                                                                                removeQuestion(
                                                                                    questionIndex
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <InputField
                                                                        type="text"
                                                                        lable={
                                                                            ''
                                                                        }
                                                                        name={`questions.${questionIndex}.questionTitle`}
                                                                        value={
                                                                            question.questionTitle
                                                                        }
                                                                        onChange={
                                                                            handleChange
                                                                        }
                                                                        onBlur={
                                                                            handleBlur
                                                                        }
                                                                        error={
                                                                            undefined
                                                                        }
                                                                        touched={
                                                                            !!(
                                                                                Array.isArray(
                                                                                    touched.questions
                                                                                ) &&
                                                                                touched
                                                                                    .questions[
                                                                                    questionIndex
                                                                                ] &&
                                                                                touched
                                                                                    .questions[
                                                                                    questionIndex
                                                                                ]
                                                                                    .questionTitle
                                                                            )
                                                                        }
                                                                        placeholder="Enter Question"
                                                                    />
                                                                </div>
                                                                <ErrorMessage
                                                                    name={`questions.${questionIndex}.questionTitle`}
                                                                    component="div"
                                                                    className="error"
                                                                />

                                                                <FieldArray
                                                                    name={`questions.${questionIndex}.questionOptions`}
                                                                >
                                                                    {({
                                                                        push: pushOption,
                                                                        remove: removeOption,
                                                                    }) => (
                                                                        <div>
                                                                            {question.questionOptions.map(
                                                                                (
                                                                                    option: any,
                                                                                    optionIndex: number
                                                                                ) => (
                                                                                    <div
                                                                                        key={
                                                                                            optionIndex
                                                                                        }
                                                                                    >
                                                                                        <div className="row mrg-top options">
                                                                                            <div className="col-sm-6 col-md-9 bg-green-color">
                                                                                                <InputGroup className="mt-2">
                                                                                                    <Form.Control
                                                                                                        placeholder={`Enter Option ${String.fromCharCode(65 + optionIndex)}`}
                                                                                                        aria-label="Username"
                                                                                                        aria-describedby="basic-addon1"
                                                                                                        name={`questions.${questionIndex}.questionOptions.${optionIndex}.text`}
                                                                                                        id={`questions.${questionIndex}.questionOptions.${optionIndex}.text`}
                                                                                                        value={
                                                                                                            option.text
                                                                                                        }
                                                                                                        onChange={
                                                                                                            handleChange
                                                                                                        }
                                                                                                        onBlur={
                                                                                                            handleBlur
                                                                                                        }
                                                                                                    />
                                                                                                    <InputGroup.Text id="basic-addon1">
                                                                                                        <Icon
                                                                                                            cursor={
                                                                                                                'pointer'
                                                                                                            }
                                                                                                            icon="icon-park-outline:delete"
                                                                                                            className="icon-secondary"
                                                                                                            color="#DA0808"
                                                                                                            onClick={() =>
                                                                                                                question
                                                                                                                    .questionOptions
                                                                                                                    .length <=
                                                                                                                2
                                                                                                                    ? dispatch(
                                                                                                                          SHOW_NOTIFICATION(
                                                                                                                              {
                                                                                                                                  type: 'error',
                                                                                                                                  message:
                                                                                                                                      'A question must have a minimum of two options',
                                                                                                                              }
                                                                                                                          )
                                                                                                                      )
                                                                                                                    : removeOption(
                                                                                                                          optionIndex
                                                                                                                      )
                                                                                                            }
                                                                                                        />
                                                                                                    </InputGroup.Text>
                                                                                                </InputGroup>
                                                                                            </div>
                                                                                            <div className="col-md-3 checklist">
                                                                                                <li className="emp-rad">
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        id={`option_${questionIndex}_${optionIndex}_correct`}
                                                                                                        name={`questions.${questionIndex}.questionOptions.${optionIndex}.correct`}
                                                                                                        checked={
                                                                                                            option.correct
                                                                                                        }
                                                                                                        onChange={() => {
                                                                                                            const checkedOptionIndex =
                                                                                                                optionIndex
                                                                                                            const correctAnswerText =
                                                                                                                option.text
                                                                                                            const updatedOptions =
                                                                                                                values.questions[
                                                                                                                    questionIndex
                                                                                                                ].questionOptions.map(
                                                                                                                    (
                                                                                                                        opt: {
                                                                                                                            correct: boolean
                                                                                                                            [
                                                                                                                                key: string
                                                                                                                            ]: any
                                                                                                                        },
                                                                                                                        idx: number
                                                                                                                    ) => ({
                                                                                                                        ...opt,
                                                                                                                        correct:
                                                                                                                            idx ===
                                                                                                                            checkedOptionIndex,
                                                                                                                    })
                                                                                                                )
                                                                                                            setFieldValue(
                                                                                                                `questions.${questionIndex}.questionOptions`,
                                                                                                                updatedOptions
                                                                                                            )
                                                                                                            setFieldValue(
                                                                                                                `questions.${questionIndex}.correctAnswer`,
                                                                                                                correctAnswerText
                                                                                                            )
                                                                                                        }}
                                                                                                    />
                                                                                                    <label
                                                                                                        htmlFor={`option_${questionIndex}_${optionIndex}_correct`}
                                                                                                    >
                                                                                                        Correct
                                                                                                        one
                                                                                                    </label>
                                                                                                </li>
                                                                                            </div>
                                                                                            <ErrorMessage
                                                                                                name={`questions.${questionIndex}.questionOptions.${optionIndex}.text`}
                                                                                                component="div"
                                                                                                className="error"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            )}

                                                                            <ErrorMessage
                                                                                name={`questions.${questionIndex}.correctAnswer`}
                                                                                component="div"
                                                                                className="error"
                                                                            />
                                                                            <div className="row mt-2">
                                                                                <div className="col-sm-6 button-block">
                                                                                    <div className="row mt-4 mb-4">
                                                                                        <div className="col-sm-6 button-block">
                                                                                            <a
                                                                                                className="button button-primary"
                                                                                                onClick={() =>
                                                                                                    pushOption(
                                                                                                        {
                                                                                                            text: '',
                                                                                                            correct:
                                                                                                                false,
                                                                                                        }
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                ADD
                                                                                                OPTION
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </FieldArray>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                                <div className="row mt-4 mb-4">
                                                    <div className="col-sm-6 button-block">
                                                        <a
                                                            className="button button-primary me-5"
                                                            onClick={() =>
                                                                push({
                                                                    questionTitle:
                                                                        '',
                                                                    questionOptions:
                                                                        [
                                                                            {
                                                                                text: '',
                                                                                correct:
                                                                                    false,
                                                                            },
                                                                            {
                                                                                text: '',
                                                                                correct:
                                                                                    false,
                                                                            },
                                                                            {
                                                                                text: '',
                                                                                correct:
                                                                                    false,
                                                                            },
                                                                            {
                                                                                text: '',
                                                                                correct:
                                                                                    false,
                                                                            },
                                                                        ],
                                                                    correctAnswer:
                                                                        undefined,
                                                                })
                                                            }
                                                        >
                                                            ADD QUESTION
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </FieldArray>

                                    <div className="row mt-4 mb-4">
                                        <div className="d-flex justify-content-between">
                                            <div></div>
                                            <div>
                                                <div className="button-block button-block-inline">
                                                    <Button
                                                        className="button button-primary me-5"
                                                        type="submit"
                                                    >
                                                        {Object.keys(
                                                            questionnaireData
                                                        ).length === 0
                                                            ? 'CREATE'
                                                            : 'UPDATE'}
                                                    </Button>
                                                    <Button
                                                        className="button button-outline"
                                                        type="button"
                                                        onClick={() =>
                                                            navigate(
                                                                '/resources'
                                                            )
                                                        }
                                                    >
                                                        CANCEL
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default CreateQuestion
